import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import { ConnectedProps, connect } from "react-redux"
import DeprecatedUserSelect from "../../../common/user/selection.component.jsx"
import IntlProps from "../../../state/helpers/IntlProps"
import { ORDER } from "../../../state/order/Constants"
import OrderService from "../../../state/order/OrderService"
import PricingTableRowService from "../../../state/pricing/PricingTableRowService"
import { setGetPricingTableItem } from "../../../state/pricing/actions"
import { PRICING_TABLE } from "../../../utils/pricing/constants"

type OwnProps = {
    objectId: string,
    assignedToUserId: string,
    itemIdList: Set<string>,
    onClose: (assignedUser: string) => void,
    onUpdateCallback: () => void,
    mainObject: string,
}

const messages = defineMessages({
    "bulk_save_type_error": {
        id: "quote.items.bulk_save_type_error",
        defaultMessage: "\"Invalid object type. Cannot save.\"",
    },
})

const ItemBulkUpdateAssignedUser = (props: Props & IntlProps) => {
    const [assignedToUserId, setAssignedUser] = useState<string>(props.assignedToUserId)
    const [errorMsg, setErrorMsg] = useState<string>("")

    const changeAssignedUser = (event) => {
        event.preventDefault()
        setErrorMsg("")
        const field = "assignedToUserId"
        const payload = {
            [field]: assignedToUserId,
            rowIds: Array.from(props.itemIdList.values()),
        }

        let res
        switch (props.mainObject) {
        case ORDER:
            res = OrderService.applyBulkUpdate(props.objectId, payload)
            break
        case PRICING_TABLE:
            res = PricingTableRowService.applyBulkUpdate(props.objectId,payload)
            break
        default:
            setErrorMsg(props.intl.formatMessage(messages["bulk_save_type_error"]))
            return
        }

        res.then((r) => {
            if (!r.error) {
                if (Array.from(props.itemIdList.values()).length > 1) {
                    if (props.onUpdateCallback) {
                        props.onUpdateCallback()
                    }
                } else {
                    props.setGetPricingTableItem(Array.from(props.itemIdList.values())[0], props.objectId, props.mainObject)
                }
                props.onClose("")
            } else {
                setErrorMsg(r.error.message)
            }
        })
    }

    const handleAssignedUserChange = (assignedToUserId: string) => {
        setAssignedUser(assignedToUserId)
    }

    const closeModals = (event) => {
        event.preventDefault()
        props.onClose("")
    }

    return (
        <Modal show={true} onHide={props.onClose} centered={true}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5 className="modal-title pb-0 mb-0 border-0" id="setAssignedUserModalLabel">
                        <FormattedMessage
                            id="quote.set_user_modal.title"
                            defaultMessage="Assigned User"
                        />
                    </h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="container-fluid">
                    <DeprecatedUserSelect
                        value={assignedToUserId}
                        onChange={
                            (selected) => handleAssignedUserChange(selected as string)
                        }
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className="text-danger">{errorMsg}</div>
                <button type="button" className="btn btn-secondary" onClick={closeModals}>
                    <FormattedMessage
                        id="quote.set_user_modal.close_btn"
                        defaultMessage="Close"
                    />
                </button>
                <button type="button" className="btn btn-primary" onClick={changeAssignedUser}
                    disabled={assignedToUserId ? false : true}>
                    <FormattedMessage
                        id="quote.set_user_modal.change_btn"
                        defaultMessage="Change Assigned User"
                    />
                </button>
            </Modal.Footer>
        </Modal>
    )
}

const mapState = (state, props: OwnProps) => {
    return {
        ...props
    }
}
const mapDispatch = { setGetPricingTableItem }
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(ItemBulkUpdateAssignedUser))


// WEBPACK FOOTER //
// ./src/common/quote/component/ItemBulkUpdateAssignedUser.tsx